import { RANKING_TAG_LIST, DEFAULT_RANKING_TAG_BG } from '../common/constant';
export function getRankTagImage(index) {
    const rankNum = index + 1;
    const isRankLargeTen = rankNum > 9;
    const rankingImg = isRankLargeTen ? DEFAULT_RANKING_TAG_BG : RANKING_TAG_LIST[index];
    return rankingImg;
}
